import Link from 'next/link';
import { useTranslation } from 'react-i18next';

import LanguageSelector from '@/shared/components/atoms/LanguageSelector';
import LogoutItem from '@/shared/components/molecules/SideMenu/ProfileMenuList/Logout';
import SideMenuNestedRoutes from '@/shared/components/molecules/SideMenu/SideMenuNestedRoutes';
import { ISideMenu } from '@/shared/components/molecules/SideMenu/types';
import routes from '@/shared/constant/routes';

import Bill from '~/images/shared/Bill.svg';
import Profile from '~/images/shared/Profile.svg';
const ProfileMenuList: React.FC<{ openCollapse: boolean }> = ({
  openCollapse,
}) => {
  const { t } = useTranslation('navigation');

  const menuProfileItem: ISideMenu.RouteItem = {
    route: routes.billing,
    title: t('profile'),
    icon: <Profile />,
    clickable: true,
    revealRoute: true,
    nestedMenu: [
      {
        customItem: <LanguageSelector />,
      },
      {
        route: routes.billing,
        title: t('billing'),
        icon: <Bill />,
        clickable: true,
      },
    ],
  };

  return (
    <SideMenuNestedRoutes
      item={menuProfileItem}
      openCollapse={openCollapse}
      footer={
        <div className='flex flex-col'>
          <Link href={routes.terms} legacyBehavior>
            <a className='p-2 text-12 font-regular capitalize text-surface-10 underline'>
              {t('terms-conditions')}
            </a>
          </Link>
          <Link href={routes.policy} legacyBehavior>
            <a className='p-2 text-12 font-regular capitalize text-surface-10 underline'>
              {t('privacy-policy')}
            </a>
          </Link>
          <LogoutItem />
        </div>
      }
    />
  );
};
export default ProfileMenuList;
